import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'TRANSFERENCIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'TRANSFERENCIA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('transferenciaForm', registro)
    ];
}

export function setFiltro(filtro) {
    return {
        type: 'TRANSFERENCIA_SET_FILTRO',
        payload: filtro
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/transferencia`);
    return {
        type: 'TRANSFERENCIA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/transferencia`, {
				...registro,
                codigo_sm_ida: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_ida, 0)) || null,
                codigo_sm_volta: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_volta, 0)) || null,
				itens: (registro.itens || []).map(item => ({
					...item,
                    quantidade: FormatUtils.formatarValorBanco(item.quantidade, 2),
                    preco: FormatUtils.formatarValorBanco(item.preco, 4)
                })),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/transferencia`, {
				...registro,
                codigo_sm_ida: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_ida, 0)) || null,
                codigo_sm_volta: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_volta, 0)) || null,
				itens: (registro.itens || []).map(item => ({
					...item,
                    quantidade: FormatUtils.formatarValorBanco(item.quantidade, 2),
                    preco: FormatUtils.formatarValorBanco(item.preco, 4)
                })),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function carregar(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/transferencia/carregar`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function descarregar(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/transferencia/descarregar`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function desfazer(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/transferencia/desfazer`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/transferencia?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'TRANSFERENCIA_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'TRANSFERENCIA_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaTanque() {
    const request = axios.get(`${consts.API_URL}/tanque/listarSelect`);
    return {
        type: 'TRANSFERENCIA_TANQUE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCliente() {
    const request = axios.get(`${consts.API_URL}/cliente/listarSelect`);
    return {
        type: 'TRANSFERENCIA_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'TRANSFERENCIA_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'TRANSFERENCIA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

//Carregamento

export function getListaCargaBase() {
    const request = axios.get(`${consts.API_URL}/transferencia?base_carga=true`);
    return {
        type: 'TRANSFERENCIA_CARGA_BASE_LISTADO',
        payload: request
    };
}

export function alterarCargaBase(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.put(`${consts.API_URL}/transferencia/alterarCargaBase`, {
			...registro
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaCargaBase());
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

//Descarga

export function getListaDescargaBase() {
    const request = axios.get(`${consts.API_URL}/transferencia?base_descarga=true`);
    return {
        type: 'TRANSFERENCIA_DESCARGA_BASE_LISTADO',
        payload: request
    };
}

export function alterarDescargaBase(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/transferencia/alterarDescargaBase`, {
			...registro
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaDescargaBase());
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}